import { render, staticRenderFns } from "./GoogleMap.vue?vue&type=template&id=4a90f2c8"
import script from "./GoogleMap.vue?vue&type=script&lang=js"
export * from "./GoogleMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PhoneIcon: require('/vercel/path0/components/icons/PhoneIcon.vue').default,MailIcon: require('/vercel/path0/components/icons/MailIcon.vue').default,HomeIcon: require('/vercel/path0/components/icons/HomeIcon.vue').default,Container: require('/vercel/path0/components/shared/Container.vue').default})
